const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class Legion extends Tactic {
    constructor() {
        super(
            Age.Age1,
            TacticNames.Legion,
            [3, 0, 0],
            "2",
            {}
        )
    }
}

module.exports = Legion;